import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  RunnoCreateModel,
  RunnoUpdateModel,
  RunnoUpdateSchema,
} from './mutation.schema'

export async function createRunno(data: RunnoCreateModel): Promise<void> {
  await axios.post('/api/masterdata/runno', data)
}

export const useCreateRunnoMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createRunno,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['runno'] })
    },
  })
}

export async function updateRunno(data: RunnoUpdateModel): Promise<void> {
  const patch = RunnoUpdateSchema.parse(data)
  await axios.put(`/api/masterdata/runno/${data.id}`, patch)
}

export const useUpdateRunnoMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['runno', 'update', id],
    mutationFn: updateRunno,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['runno'] })
    },
  })
}

export async function createRunnoAllYear(
  data: RunnoCreateModel
): Promise<void> {
  await axios.post('/api/masterdata/runno/create-all-year', data)
}
// createy all year runno
export const useCreateAllYearRunnoMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createRunnoAllYear,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['runno'] })
    },
  })
}

// =================  delete runno =================

export const useDeleteRunnoMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/masterdata/runno/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['runno'] })
    },
  })
}

export function getRunnoKeySelectOptions() {
  return [
    {
      label: 'เลขลำดับ BOM',
      value: 'BOM',
    },
    {
      label: 'เอกสารปรับปรุง คลังสินค้า',
      value: 'WAR-A',
    },
    {
      label: 'เอกสารรับ คลังสินค้า',
      value: 'WAR-R',
    },
    {
      label: 'เอกสารเบิก คลังสินค้า',
      value: 'WAR-W',
    },
    {
      label: 'ใบ hold FG',
      value: 'HOLD-FG',
    },
    {
      label: 'ใบ hold RM',
      value: 'HOLD-RM',
    },
    {
      label: 'ใบ hold in-process',
      value: 'HOLD-IN',
    },
    {
      label: 'เลข Lot การผลิตเครื่องจักร {machine}',
      value: 'WoLotNo-{MACHINE}',
    },
    {
      label: 'เลข Lot การผลิตเครื่องจักร {machine} เพื่อทดสอบ',
      value: 'WoLotNo-T{MACHINE}',
    },
    {
      label: 'ใบขาย',
      value: 'SALE',
    },
  ]
}
